/**<import>****************************************************************************************************/
import React, { Component } from 'react';
import * as agCharts from 'ag-charts-community';
import { AgChartsReact } from 'ag-charts-react';
import _ from 'underscore';
import moment from 'moment';


class ChartDisplay extends Component {
  constructor(props) {
    super(props);
    this.getPieData = this.getPieData.bind(this);
    this.getStackedBarData = this.getStackedBarData.bind(this);
    this.groupBy = this.groupBy.bind(this);
    this.groupByInner = this.groupByInner.bind(this);
    this.getGroupedBarData2 = this.getGroupedBarData2.bind(this);
  };

  getSafeChartOptions = (options) => {
    const safeOptions = { ...options };
    const defaultPadding = { top: 12, right: 12, bottom: 8, left: 8 };

    if (!safeOptions.background || typeof safeOptions.background !== 'object') {
      safeOptions.background = { fill: '#ffffff' };
    } else if (typeof safeOptions.background.fill === 'undefined') {
      safeOptions.background = { ...safeOptions.background, fill: '#ffffff' };
    }

    if (!safeOptions.padding || typeof safeOptions.padding !== 'object') {
      safeOptions.padding = defaultPadding;
    } else {
      safeOptions.padding = {
        top: safeOptions.padding.top ?? defaultPadding.top,
        right: safeOptions.padding.right ?? defaultPadding.right,
        bottom: safeOptions.padding.bottom ?? defaultPadding.bottom,
        left: safeOptions.padding.left ?? defaultPadding.left
      };
    }

    return safeOptions;
  };

  getSeriesPalette = (count) => {
    const size = Number.isFinite(count) && count > 0 ? count : 0;
    const palette = this.props.corporate ? corporatePalette : myTheme.palette.fills;
    const fallbackStroke = this.props.corporate ? '#163a5f' : '#09253D';
    const fills = [];
    const strokes = [];

    for (let i = 0; i < size; i++) {
      const fill = palette[i % palette.length];
      fills.push(fill);
      strokes.push(fallbackStroke);
    }

    return { fills, strokes };
  };

  normalizeSeriesMatrix = (rows, xKey, labels) => {
    if (!Array.isArray(rows) || !Array.isArray(labels)) {
      return [];
    }

    return rows
      .filter(row => row && typeof row[xKey] !== 'undefined' && row[xKey] !== null)
      .map(row => {
        const nextRow = { ...row };
        labels.forEach((labelKey) => {
          const hasDirect = Object.prototype.hasOwnProperty.call(nextRow, labelKey);
          const aliasKey = typeof labelKey === 'string' && labelKey.endsWith(' asset mv')
            ? labelKey.slice(0, -' asset mv'.length)
            : `${labelKey} asset mv`;
          const aliasValue = nextRow[aliasKey];
          const rawValue = hasDirect ? nextRow[labelKey] : aliasValue;
          const normalizedValue = typeof rawValue === 'number'
            ? rawValue
            : Number(String(rawValue ?? '').replace(/,/g, '').trim());
          nextRow[labelKey] = Number.isFinite(normalizedValue) ? normalizedValue : 0;
        });
        return nextRow;
      });
  };

  groupByInner = (array, key, value) => {
    return array.reduce((result, currentValue) => {
      result[currentValue.P[0][key]] = (result[currentValue.P[0][key]] || 0) + currentValue[value]
      return result;
    }, {});
  };

  groupBy = (array, key, value) => {
    if(array) {
      return array.reduce((result, currentValue) => {
        const rawBucket = currentValue?.[key];
        if ((typeof rawBucket === 'string' && rawBucket.trim().length === 0) || rawBucket === null || typeof rawBucket === 'undefined') {
          return result;
        }
        const bucket = rawBucket;

        const rawValue = currentValue?.[value];
        const normalizedValue = typeof rawValue === 'number'
          ? rawValue
          : Number(String(rawValue ?? '').replace(/,/g, '').trim());
        const safeValue = Number.isFinite(normalizedValue) ? normalizedValue : 0;
        result[bucket] = (result[bucket] || 0) + safeValue;
        return result;
      }, {});
    }
    else {
      return null;
    }
  };

  getPieData = (data, GroupBy, sumCol) => {
    var grouped = this.groupBy(data, GroupBy, sumCol);
    var chartList = [];
    var labels = [];
    var sum = 0;

    for (var key in grouped) {
      if (grouped[key] !== 0) {
        var chart = {
          [`${GroupBy}`]: key,
          [`${sumCol}`]: grouped[key]
        }

        sum = sum + grouped[key];

        if (labels.includes(key) === false) {
          labels.push(key);
        }

        chartList.push(chart);
      }
    }

    labels.sort();

    return [chartList, labels, sum];
  }

  getStackedBarData = (data, GroupBy, xKey, sumCol) => {
    var grouped = this.groupBy(data, xKey, sumCol);

    var chartMaturityList = [];
    var maturityLabel = [];
    var sumList = [];

    for (let key in grouped) {
      if (grouped[key] !== 0) {
        var arr = data.filter(function (item) {
          return item[xKey] === key || item[xKey] === parseInt(key)
        });

        var sub_grouped = this.groupBy(arr, GroupBy, sumCol);

        var chart = {
          [`${xKey}`]: key
        }

        sumList.push({ [`${xKey}`]: key, sumVal: grouped[key]});

        for (var key2 in sub_grouped) {
          if (sub_grouped[key2] !== 0) {
            chart[`${key2} ${sumCol}`] = sub_grouped[key2];

            if (maturityLabel.includes(`${key2} ${sumCol}`) === false) {
              maturityLabel.push(`${key2} ${sumCol}`)
            }
          } else if(sub_grouped[key2] === 0 && key2 !== "Uncategorized") {
            chart[`${key2} ${sumCol}`] = 0;

            if (maturityLabel.includes(`${key2} ${sumCol}`) === false) {
              maturityLabel.push(`${key2} ${sumCol}`)
            }
          }
        }

        chartMaturityList.push(chart);
      }
    }

    maturityLabel.sort();

    return [chartMaturityList, maturityLabel, sumList];
  }

  getGroupedBarDataAlt = (data, xKey, sumCol, funds) => {
    var reportDate = _.keys(_.countBy(data, function(data) { return data[xKey]; }));
    var chartMaturityList = [];

    for(let i = 0; i < reportDate.length; i++){
      var chart = {
        [`${xKey}`]: reportDate[i]
      }

      var filteredData = data.filter(row => row[xKey] === reportDate[i]);

      for(let j = 0; j < funds.length; j++){
        var filteredDataFund = filteredData.filter(row => row['fund'] === funds[j]);

        const num = filteredDataFund.reduce( (numerator, row) => numerator + row[sumCol[0]], 0);
        const den = filteredDataFund.reduce( (numerator, row) => numerator + row[sumCol[1]], 0);

        chart[`${funds[j]}`] = ((den ?? 0) > 0 ? num / den : 0);
      }

      chartMaturityList.push(chart);
    }

    return [chartMaturityList, funds];
  }

  getGroupedBarData2 = (data, xKey, sumCol, funds) => {
    var reportDate = _.keys(_.countBy(data, function(data) { return data[xKey]; }));
    var chartMaturityList = [];

    for(let i = 0; i < reportDate.length; i++){
      var chart = {
        [`${xKey}`]: reportDate[i]
      }

      var filteredData = data.filter(row => row[xKey] === reportDate[i]);

      for(let j = 0; j < funds.length; j++){
        var filteredDataFund = filteredData.filter(row => row['fund'] === funds[j]);

        const num = filteredDataFund.reduce( (numerator, row) => numerator + row[sumCol], 0);

        chart[`${funds[j]}`] = num;
      }

      chartMaturityList.push(chart);
    }

    return [chartMaturityList, funds];
  }

  getGroupedBarData = (data, xKey, sumCol) => {
    var reportDate = _.keys(_.countBy(data, function(data) { return data[xKey]; }));
    var chartMaturityList = [];

    for(let i = 0; i < reportDate.length; i++){
      var chart = {
        [`${xKey}`]: reportDate[i]
      }
      for(let j = 0; j < sumCol.length; j++){
        var filteredData = data.filter(row => row[xKey] === reportDate[i]);
        const value = filteredData.reduce( (numerator, row) => numerator + row[sumCol[j]], 0);
        chart[`${sumCol[j]}`] = value;
      }

      chartMaturityList.push(chart);
    }

    return [chartMaturityList, sumCol];
  }



  render() {
    var dataList, angle, options, lData, labels;
    if (this.props.chartType === 'pie') {
      lData = this.getPieData(this.props.dataList, this.props.labelKey, this.props.angleKey);
      dataList = lData[0];
      dataList.sort((a, b) => (a[this.props.angleKey] < b[this.props.angleKey]) ? 1 : -1)

      labels = lData[1];
      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 8, right: 8, bottom: 8, left: 8 } : { top: 8, right: 8, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            type: 'pie',
            angleKey: this.props.angleKey,
            labelKey: this.props.labelKey,
            strokeWidth: this.props.borderless ? 0 : 1,
            innerRadiusOffset: this.props.corporate ? -52 : 0,
            outerRadiusOffset: this.props.corporate ? -6 : 0,
            label: this.props.corporate ? {
              enabled: false
            } : undefined,
            highlightStyle: this.props.corporate ? {
              fill: '#4f7fae',
              stroke: '#ffffff',
              centerOffset: 4
            } : undefined,
            tooltip: {
              renderer: function (params) {
                return {
                  content: params.datum[params.labelKey] + ":" + 
                    params.angleValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") + 
                    " (" + (params.angleValue / lData[2] * 100).toFixed(2) + "%) " ,
                };
              },
            },
          }
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'bar-stacked') {
      if (!Array.isArray(this.props.dataList) || this.props.dataList.length === 0 || !this.props.xKey || !this.props.GroupBy || !this.props.yKeys) {
        return null;
      }

      lData = this.getStackedBarData(this.props.dataList, this.props.GroupBy, this.props.xKey, this.props.yKeys);
      dataList = lData[0];
      labels = lData[1];
      const validLabels = labels.filter(label => typeof label === 'string' && label.trim().length > 0);
      if (!Array.isArray(dataList) || dataList.length === 0 || !Array.isArray(labels) || labels.length === 0) {
        return null;
      }
      if (validLabels.length === 0) {
        return null;
      }

      dataList = this.normalizeSeriesMatrix(dataList, this.props.xKey, validLabels);

      if (dataList.length === 0) {
        return null;
      }

      dataList.sort((a, b) => (a[this.props.xKey] > b[this.props.xKey]) ? 1 : -1)

      angle = 360;
      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      } 

      const seriesPalette = this.getSeriesPalette(validLabels.length);
      const seriesList = validLabels.map((labelKey, index) => ({
        type: 'column',
        xKey: this.props.xKey,
        yKey: labelKey,
        yName: labelKey,
        stacked: true,
        fill: seriesPalette.fills[index],
        stroke: seriesPalette.strokes[index],
        strokeWidth: this.props.borderless ? 0 : 1,
        highlightStyle: this.props.corporate ? {
          fill: '#4f7fae',
          stroke: '#4f7fae'
        } : undefined,
        tooltip: {
          renderer: function (params) {
            return {
              content: params.xValue + ' : ' + params.yValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
            };
          },
        }
      }));

      if (seriesList.length === 0) {
        return null;
      }

      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: seriesList,
        axes: [
          {
            type: 'category',
            position: 'bottom',
            label: {
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'bar-stacked-prepared') {
      if (!Array.isArray(this.props.dataList) || this.props.dataList.length === 0 || !this.props.xKey || !Array.isArray(this.props.yKeys) || this.props.yKeys.length === 0) {
        return null;
      }

      const validLabels = this.props.yKeys.filter(label => typeof label === 'string' && label.trim().length > 0);
      if (validLabels.length === 0) {
        return null;
      }
      const validNames = validLabels.map((labelKey, index) => {
        if (Array.isArray(this.props.yNames) && typeof this.props.yNames[index] === 'string' && this.props.yNames[index].trim().length > 0) {
          return this.props.yNames[index];
        }
        return labelKey;
      });

      dataList = this.normalizeSeriesMatrix(this.props.dataList, this.props.xKey, validLabels);

      if (dataList.length === 0) {
        return null;
      }

      angle = 360;
      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      const seriesList = [{
        type: 'column',
        xKey: this.props.xKey,
        yKeys: validLabels,
        yNames: validNames,
        stacked: true,
        strokeWidth: this.props.borderless ? 0 : 1,
        highlightStyle: this.props.corporate ? {
          fill: '#4f7fae',
          stroke: '#4f7fae'
        } : undefined,
        tooltip: {
          renderer: function (params) {
            const yValue = Number(params.yValue);
            const displayValue = Number.isFinite(yValue) ? yValue : 0;
            return {
              content: params.xValue + ' : ' + displayValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
            };
          },
        }
      }];

      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: seriesList,
        axes: [
          {
            type: 'category',
            position: 'bottom',
            label: {
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'bar-grouped') {
      lData = this.getGroupedBarData(this.props.dataList, this.props.xKey, this.props.yKeys);
      dataList = lData[0];
      dataList.sort((a, b) => (a[this.props.xKey] > b[this.props.xKey]) ? 1 : -1)
      labels = lData[1];
      angle = 360;
      if (this.props.rotationAngle){
        angle = this.props.rotationAngle;
      }

      options = {
        theme: myTheme,
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            type: 'column',
            xKey: this.props.xKey,
            yKeys: labels,
            yNames: labels,
            tooltip: {
              renderer: function (params) {
                return {
                  content: params.xValue + ' : ' + params.yValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
                };
              },
            },
            grouped: true
          }
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
            label: {
              rotation: angle
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
            },
          },
        ],
        legend: { enabled: true, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'line-grouped') {
      lData = this.getGroupedBarData(this.props.dataList, this.props.xKey, this.props.yKeys);
      dataList = lData[0];
      labels = lData[1];
      angle = 360;

      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (var i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            xKey: this.props.xKey,
            yKey: labels,
            yName: labels,
            ...(this.props.corporate && {
              stroke: corporatePalette[0],
              strokeWidth: 2.5,
              marker: {
                enabled: false,
                fill: corporatePalette[0],
                stroke: corporatePalette[0]
              },
              highlightStyle: {
                fill: corporatePalette[0],
                stroke: corporatePalette[0]
              }
            }),
            tooltip: {
              renderer: function (params) {
                return {
                  content: moment(params.xValue).format("YYYY-MM-DD") + ' : ' + params.yValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
                };
              },
            },
            grouped: true
          }
        ],
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: {count: agCharts.time.month},
            label: {
              format: '%b %Y',
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined,
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: true, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'line-grouped-alt') {
      const fundList = this.props.fund === 'All'? ['TOR', 'TIFO', 'TACO', 'TACO II', 'TACO III', 'TACO IV', 'TALC'] : [this.props.fund]
      lData = this.getGroupedBarDataAlt(this.props.dataList, this.props.xKey, this.props.sumKeys, fundList);
      dataList = lData[0];
      labels = lData[1];
      angle = 360;

      var seriesList = [];

      for(let i = 0; i < fundList.length; i++) {
        const seriesColor = corporatePalette[i % corporatePalette.length];
        seriesList.push({
          xKey: this.props.xKey,
          yKey: fundList[i],
          yName: fundList[i],
          ...(this.props.corporate && {
            stroke: seriesColor,
            strokeWidth: 2.5,
            marker: {
              enabled: false,
              fill: seriesColor,
              stroke: seriesColor
            },
            highlightStyle: {
              fill: seriesColor,
              stroke: seriesColor
            }
          }),
          tooltip: {
            renderer: function (params) {
              return {
                content: moment(params.xValue).format("YYYY-MM-DD") + ' : ' + params.yValue.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
              };
            },
          },
          grouped: true
        })
      }

      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (let i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      options = {
        theme: this.props.corporate ? corporateTheme : lineTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: seriesList,
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: {count: 10},
            label: {
              format: '%b %Y',
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: true, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'line-grouped-alt2') {
      const fundList = ['TOR', 'TIFO', 'TACO', 'TACO II', 'TACO III', 'TACO IV', 'TALC']
      lData = this.getGroupedBarData2(this.props.dataList, this.props.xKey, this.props.sumKeys, fundList);
      dataList = lData[0];
      labels = lData[1];
      angle = 360;

      seriesList = [];

      for(let i = 0; i < fundList.length; i++) {
        seriesList.push({
          xKey: this.props.xKey,
          yKey: fundList[i],
          yName: fundList[i],
          marker: {
            enabled: false
          },
          highlightStyle: this.props.corporate ? {
            fill: '#4f7fae',
            stroke: '#2f6db3'
          } : undefined,
          tooltip: {
            renderer: function (params) {
              return {
                content: moment(params.xValue).format("YYYY-MM-DD") + ' : ' + params.yValue.toFixed(2).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
              };
            },
          },
          grouped: true
        })
      }

      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (let i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      options = {
        theme: lineTheme,
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: seriesList,
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: {count: 5},
            label: {
              format: '%d %b %Y',
              rotation: angle
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
            },
          },
        ],
        legend: { enabled: true, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'area') {
      lData = this.getStackedBarData(this.props.dataList, this.props.GroupBy, this.props.xKey, this.props.yKeys);
      dataList = lData[0];

      angle = 360;
      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (let i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      labels = lData[1];
      options = {
        theme: areaTheme,
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            type: 'area',
            xKey: this.props.xKey,
            yKeys: labels,
            yNames: labels
          }
        ],
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: { count: agCharts.time.month },
            label: { format: '%b %Y', rotation: angle }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value + '%';
              },
            },
          },
        ],
        legend: { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'area-mln') {
      lData = this.getStackedBarData(this.props.dataList, this.props.GroupBy, this.props.xKey, this.props.yKeys);
      dataList = lData[0];

      angle = 360;
      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (let i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      labels = lData[1];
      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            type: 'area',
            xKey: this.props.xKey,
            yKeys: labels,
            yNames: labels,
            fillOpacity: this.props.corporate ? 0.72 : 1,
            strokeWidth: this.props.corporate ? 1.5 : 1,
            marker: {
              enabled: false
            },
            highlightStyle: this.props.corporate ? {
              fill: '#4f7fae',
              stroke: '#2f6db3'
            } : undefined,
            tooltip: {
              renderer: function (params) {
                if (params.processedYValue === 0 && params.yValue !== 0) {
                  return '';
                }

                return {
                  content: moment(params.xValue).format('YYYY-MM-DD') + ' : ' + params.yValue.toFixed(0).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ","),
                };
              },
            },
          }
        ],
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: { count: 10 },
            label: {
              format: '%b %Y',
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === 'area-normalized') {
      lData = this.getStackedBarData(this.props.dataList, this.props.GroupBy, this.props.xKey, this.props.yKeys);
      dataList = lData[0];

      angle = 360;
      if (this.props.rotationAngle) {
        angle = this.props.rotationAngle;
      }

      for (let i = 0; i < dataList.length; i++) {
        dataList[i][this.props.xKey] = new Date(dataList[i][this.props.xKey]);
      }

      labels = lData[1];
      options = {
        theme: this.props.corporate ? corporateTheme : myTheme,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        data: dataList,
        title: {
          text: this.props.chartTitle
        },
        series: [
          {
            type: 'area',
            xKey: this.props.xKey,
            yKeys: labels,
            yNames: labels,
            normalizedTo: 100,
            fillOpacity: this.props.corporate ? 0.72 : 1,
            strokeWidth: this.props.corporate ? 1.5 : 1,
            marker: {
              enabled: false
            },
            tooltip: {
              renderer: function (params) {
                if (params.processedYValue === 0 && params.yValue !== 0) {
                  return '';
                }

                return {
                  content: moment(params.xValue).format('YYYY-MM-DD') + ' : ' + params.processedYValue.toFixed(2) + "%",
                };
              },
            },
          }
        ],
        axes: [
          {
            type: 'time',
            nice: false,
            position: 'bottom',
            tick: { count: 10 },
            label: {
              format: '%b %Y',
              rotation: angle,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value + '%';
              },
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      }

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === "cartesian") {
      options = {
        type: 'cartesian',
        theme: areaTheme,
        autoSize: true,
        title: {
          enabled: true,
          text: 'Historical Cashflows',
        },
        data: this.props.data,
        series: [
          {
            type: 'column',
            xKey: this.props.xKey,
            yKeys: this.props.yKeys,
            yNames: this.props.yNames
          },
          {
            type: 'line',
            xKey: this.props.xKey,
            yKey: this.props.yKeyLine,
            yName: 'Cumulative Cashflow',
          },
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
            tick: { count: 5 },
            label: {
              rotation: 335
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              formatter: function (params) {
                return params.value / 1e6 + 'M';
              },
            },
          },
        ],
        legend: { enabled: false, position: 'bottom' }
      };

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else if (this.props.chartType === "cartesian-pnl") {
      options = {
        type: 'cartesian',
        theme: this.props.corporate ? corporateTheme : areaTheme,
        autoSize: true,
        background: {
          fill: '#ffffff'
        },
        padding: this.props.corporate ? { top: 12, right: 12, bottom: 8, left: 8 } : { top: 12, right: 12, bottom: 8, left: 8 },
        title: {
          enabled: !!this.props.chartTitle,
          text: this.props.chartTitle || 'Historical CTR',
        },
        data: this.props.data,
        series: [
          {
            type: 'column',
            xKey: this.props.xKey,
            yKeys: this.props.yKeys,
            yNames: this.props.yNames,
            fillOpacity: this.props.corporate ? 0.72 : 1,
            strokeWidth: this.props.corporate ? 1.5 : 1
          },
          {
            type: 'line',
            xKey: this.props.xKey,
            yKey: this.props.yKeyLine,
            yName: 'Cumulative CTR',
            ...(this.props.corporate && {
              stroke: corporatePalette[0],
              strokeWidth: 2.5,
              marker: {
                enabled: false,
                fill: corporatePalette[0],
                stroke: corporatePalette[0]
              },
              highlightStyle: {
                fill: corporatePalette[0],
                stroke: corporatePalette[0]
              }
            })
          },
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
            tick: { count: 5 },
            label: {
              rotation: 335,
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            }
          },
          {
            type: 'number',
            position: 'left',
            tick: { count: 5 },
            label: {
              color: this.props.corporate ? '#5f6f86' : undefined,
              fontSize: this.props.corporate ? 12 : undefined
            },
            line: {
              color: this.props.corporate ? '#d8e1ee' : undefined
            },
            gridStyle: this.props.corporate ? [{ stroke: '#edf2f7', lineDash: [4, 4] }] : undefined
          },
        ],
        legend: this.props.corporate ? corporateLegend : { enabled: false, position: 'bottom' }
      };

      return <AgChartsReact options={this.getSafeChartOptions(options)} />;
    } else {
      return null;
    }
  }
}

var corporatePalette = [
  '#163a5f',
  '#2f6db3',
  '#3f8f8b',
  '#6f88a8',
  '#c08a3e',
  '#7b6ba8',
  '#5f9f68',
  '#b65f5f'
];

var corporateTheme = {
  baseTheme: 'ag-default',
  palette: {
    fills: corporatePalette,
    strokes: corporatePalette
  }
};

var corporateLegend = {
  enabled: true,
  position: 'bottom',
  spacing: 8,
  item: {
    paddingX: 10,
    paddingY: 4,
    marker: {
      size: 9,
      padding: 5,
      strokeWidth: 0
    },
    label: {
      color: '#42556d',
      fontSize: 12
    }
  }
};

var myTheme = {
  baseTheme: 'ag-vivid',
  palette: {
    fills: [
      '#003396',
      '#5A89E6',
      '#77a2f7',
      '#91B7FF',
      '#73B9EE',
      '#A8C6FF',
      '#A5B7D9',
      '#B7E9F7',
      '#DBF3FA',
      '#AAB6D6',
      '#8FA3D9',
      '#7489CE',
      '#6275CC',
      '#5266C0',
      '#1647A6',
      '#285CBF',
      '#3D70D4',
      '#4750B8'
    ],
    strokes: [
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D'
    ]
  },
  defaults: {
    cartesian: {
      title: { fontSize: 24 },
      series: {
        column: {
          label: {
            enabled: true,
            color: 'black',
          },
        },
      },
    },
  },
};

var areaTheme = {
  baseTheme: 'ag-vivid',
  palette: {
    fills: [

      '#011f4b',
      '#5A89E6', 
      '#005b96', 
      '#6497b1', 
      '#b3cde0'

      // '#003396',
      // '#1647A6',
      // '#285CBF',
      // '#3D70D4',
      // '#5A89E6',
      // '#77a2f7',
    ],
    strokes: [
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D'
    ]
  },
  defaults: {
    cartesian: {
      title: { fontSize: 24 },
      series: {
        column: {
          label: {
            enabled: true,
            color: 'black',
          },
        },
      },
    },
  },
};

var lineTheme = {
  baseTheme: 'ag-vivid',
  palette: {
    fills: [
      '#007E86',
      '#00AC88',
      '#907245', 
      '#DFA01E',
      '#de6e56',
      '#6B4E3F',
      '#FFD700'
],
    strokes: [
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D',
      '#09253D'
    ]
  },
  defaults: {
    cartesian: {
      title: { fontSize: 24 },
      series: {
        column: {
          label: {
            enabled: true,
            color: 'black',
          },
        },
      },
    },
  },
};

export default ChartDisplay;